export const OFFLINE_TRANSLATIONS = {
  savedLocallyTitle: {
    "pt-BR": "Salvo localmente",
    en: "Saved locally",
    es: "Guardado localmente",
    de: "Lokal gespeichert",
  },
  savedLocallySyncDescription: {
    "pt-BR": "Será sincronizado quando a conexão voltar.",
    en: "It will sync when the connection is restored.",
    es: "Se sincronizará cuando vuelva la conexión.",
    de: "Die Synchronisierung erfolgt, wenn die Verbindung wiederhergestellt ist.",
  },
  queuedChangeDescription: {
    "pt-BR": "Alteração salva localmente e será sincronizada quando a conexão voltar.",
    en: "Change saved locally and will sync when the connection is restored.",
    es: "Cambio guardado localmente y se sincronizará cuando vuelva la conexión.",
    de: "Die Änderung wird lokal gespeichert und synchronisiert, wenn die Verbindung wiederhergestellt ist.",
  },
  noOfflinePatientsData: {
    "pt-BR": "Sem dados offline de pacientes. Conecte-se à internet para baixar.",
    en: "No offline patient data. Connect to the internet to download.",
    es: "Sin datos offline de pacientes. Conéctate a internet para descargar.",
    de: "Keine Offline-Patientendaten. Stellen Sie zum Herunterladen eine Verbindung zum Internet her.",
  },
  chartNotAvailableOffline: {
    "pt-BR": "Prontuário não disponível offline. Conecte-se à internet para carregar dados clínicos.",
    en: "Medical record not available offline. Connect to the internet to load clinical data.",
    es: "Historial clínico no disponible offline. Conéctate a internet para cargar datos clínicos.",
    de: "Krankenakte ist offline nicht verfügbar. Stellen Sie eine Verbindung zum Internet her, um klinische Daten zu laden.",
  },
  agendaNotAvailableOffline: {
    "pt-BR": "Agenda não disponível offline. Conecte-se à internet para baixar.",
    en: "Schedule not available offline. Connect to the internet to download.",
    es: "Agenda no disponible offline. Conéctate a internet para descargar.",
    de: "Zeitplan nicht offline verfügbar. Stellen Sie zum Herunterladen eine Verbindung zum Internet her.",
  },
  actionRequiresInternet: {
    "pt-BR": "Esta ação requer conexão com a internet.",
    en: "This action requires an internet connection.",
    es: "Esta acción requiere conexión a internet.",
    de: "Für diese Aktion ist eine Internetverbindung erforderlich.",
  },
  chatSyncFailed: {
    "pt-BR": "Falha ao sincronizar chat",
    en: "Failed to sync chat",
    es: "Error al sincronizar el chat",
    de: "Chat konnte nicht synchronisiert werden",
  },
  chatSyncFailedWithReason: {
    "pt-BR": "Não foi possível sincronizar: {reason}",
    en: "Could not sync: {reason}",
    es: "No fue posible sincronizar: {reason}",
    de: "Konnte nicht synchronisiert werden: {reason}",
  },
  messageSent: {
    "pt-BR": "Mensagem enviada",
    en: "Message sent",
    es: "Mensaje enviado",
    de: "Nachricht gesendet",
  },
  messagesSentCount: {
    "pt-BR": "{count} mensagens enviadas",
    en: "{count} messages sent",
    es: "{count} mensajes enviados",
    de: "{count} Nachrichten gesendet",
  },
  blockedUpload: {
    "pt-BR": "Upload disponível apenas com internet.",
    en: "Upload available only with internet.",
    es: "La carga de archivos solo está disponible con internet.",
    de: "Hochladen nur über das Internet möglich.",
  },
  blockedChat: {
    "pt-BR": "Chat disponível apenas com internet.",
    en: "Chat available only with internet.",
    es: "El chat solo está disponible con internet.",
    de: "Chat nur über das Internet verfügbar.",
  },
  blockedNewSession: {
    "pt-BR": "Agendar sessão disponível apenas com internet.",
    en: "Scheduling a session is available only with internet.",
    es: "Agendar sesión solo está disponible con internet.",
    de: "Das Planen einer Sitzung ist nur mit Internet möglich.",
  },
  clinicalAccessBlocked: {
    "pt-BR": "Sua conta está em modo somente cobrança. Regularize a assinatura para criar ou editar dados clínicos.",
    en: "Your account is in billing-only mode. Update your subscription to create or edit clinical data.",
    es: "Tu cuenta está en modo solo cobro. Regulariza la suscripción para crear o editar datos clínicos.",
    de: "Ihr Konto befindet sich im reinen Abrechnungsmodus. Aktualisieren Sie Ihr Abonnement, um klinische Daten zu erstellen oder zu bearbeiten.",
  },
  blockedAi: {
    "pt-BR": "Recursos de IA disponíveis apenas com internet.",
    en: "AI features available only with internet.",
    es: "Funciones de IA solo disponibles con internet.",
    de: "KI-Funktionen sind nur mit Internet verfügbar.",
  },
  loadChartError: {
    "pt-BR": "Erro ao carregar prontuário",
    en: "Error loading medical record",
    es: "Error al cargar historial clínico",
    de: "Fehler beim Laden der Krankenakte",
  },
  networkFailure: {
    "pt-BR": "Falha de rede",
    en: "Network failure",
    es: "Fallo de red",
    de: "Netzwerkfehler",
  },
} as const;
